<template>
	<j-box class="flex wrap xs-12 margin-center xs-center xs-top pr4 pl4 mt10">
		<!-- Form -->
		<template v-if="!isDone">
			<j-card class="flex wrap xs-12 xs-center p8 bg5 pt8 pb8 max5">
				<j-headline class="fs7 lh125 fw7 c1 mb2">{{
					$t("login.reset_password")
				}}</j-headline>
				<form class="flex wrap xs-12" @submit.prevent="onSubmit">
					<j-box class="lh150 c6 ta2">
						{{ $t("login.please_enter_email") }}
					</j-box>

					<!-- Email -->
					<j-box class="xs-12 mb4 mt8">
						<j-base-input-text
							id="email"
							name="email"
							v-model="email"
							v-validate="{ required: true }"
							:status="errors.first('email') ? 'error' : null"
							:placeholder="$t('login.your_email')"
						/>
						<j-text class="fs3 lh125 mt1 cError">{{
							errors.first("email")
						}}</j-text>
					</j-box>

					<!-- Button -->
					<j-box class="flex xs-12 xs-center">
						<j-button :isLoading="isLoading" size="large">
							{{ $t("login.send_reset_email") }}
						</j-button>
					</j-box>
				</form>
			</j-card>
		</template>

		<!-- Thank you page -->
		<template v-if="isDone">
			<j-card class="flex wrap xs-12 xs-center p8 bg5 max5">
				<j-headline class="xs-12 ta1 fs6 lh125 fw7 c1 mb2">{{
					$t("login.check_your_inbox")
				}}</j-headline>
				<j-box class="fs4 lh150 c6 ta1">{{
					$t("login.instructions_sent_to_email")
				}}</j-box>
			</j-card>
		</template>

		<!-- Go back to log in -->
		<j-box class="xs-12 ta2 mt6 mb10">
			<router-link :to="`/${$route.params.tenantId}/login`" class="c6">
				&larr; {{ $t("login.back_to_login") }}
			</router-link>
		</j-box>
	</j-box>
</template>

<script>
import JBox from "@/components/JBox/"
import JCard from "@/components/JCard/"
import JHeadline from "@/components/JHeadline/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseLabel from "@/components/JBaseLabel/"
import JButton from "@/components/JButton/"
import JText from "@/components/JText/"

export default {
	name: "page-login-signin",
	components: {
		JBox,
		JCard,
		JHeadline,
		JBaseInputText,
		JButton,
		JBaseLabel,
		JText
	},

	data() {
		return {
			isLoading: false,
			isDone: false,
			email: null
		}
	},

	methods: {
		async onSubmit() {
			this.isLoading = true

			this.$validator.validate().then(isValid => {
				if (isValid) {
					this.$store
						.dispatch("auth/forgotPassword", {
							email: this.email
						})
						.then(res => {
							if (res) this.isDone = true
							this.isLoading = false
						})
				} else this.isLoading = false
			})
		}
	}
}
</script>
